/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import Order12AddServiceDetail from './Order12AddServiceDetail';
import Order12AddServiceDetailKR from './Order12AddServiceDetailKR';
import ServiceDetailDialog from '../popup/serviceDetailDialog';

class Order12AddService extends React.Component {
  static propTypes = {
    vehicle: PropTypes.string.isRequired,
    modelDataText: PropTypes.shape().isRequired,
    modelData: PropTypes.shape().isRequired,
    lang: PropTypes.string.isRequired,
    orderDetailInfo: PropTypes.shape().isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      isShowServiceDetailDialog: false,
    };
    this.onClickShowServiceDetailDialog = this.onClickShowServiceDetailDialog.bind(
      this,
    );
  }

  onClickShowServiceDetailDialog(modal) {
    this.setState({ isShowServiceDetailDialog: modal });
  }

  render() {
    return (
      <div>
        <div className={s2.orderSmallTitle}>
          {this.props.modelDataText.order_additional_service_title}
          <span
            style={this.props.lang !== 'hk' ? { display: 'none' } : {}}
            className={`${s2.serviceDetail} ${s2.orderFunctionText}`}
            role="button"
            tabIndex={0}
            onClick={() => {
              this.onClickShowServiceDetailDialog(true);
            }}
            onKeyPress={() => {}}
          >
            &nbsp;{
              this.props.modelData.additional_service.button_service_detail
            }
          </span>
        </div>
        {this.props.orderDetailInfo.vehicle !== '' &&
        this.props.lang !== 'kr' ? (
          <div className={`${s2.serviceOption}`}>
            <Order12AddServiceDetail
              modelData={this.props.modelData}
              modelDataText={this.props.modelDataText}
              vehicle={this.props.vehicle}
              lang={this.props.lang}
            />
          </div>
        ) : (
          ''
        )}
        {this.props.lang === 'kr' ? (
          <div className={`${s2.serviceOption}`}>
            <Order12AddServiceDetailKR
              modelData={this.props.modelData}
              modelDataText={this.props.modelDataText}
              vehicle={this.props.vehicle}
            />
          </div>
        ) : (
          ''
        )}
        <ServiceDetailDialog
          modal={this.state.isShowServiceDetailDialog}
          onClickShow={this.onClickShowServiceDetailDialog}
        />
      </div>
    );
  }
}
const mapState = state => ({
  vehicle: state.order.vehicle,
  orderDetailInfo: state.order.orderDetailInfo,
});

export default connect(mapState)(
  withStyles(bootstrap, s, s2)(Order12AddService),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order12AddService/Order12AddService.js